import { InputContainer } from 'routes/Report/styles';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'components/Modal';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import utils from 'utils';
import TextInput from 'components/Input/TextInput';
import { DropDownOptions, ReportFilter } from 'models/report';
import services from 'services';
import action from 'state/actions';

const InputContainerCenter = styled(InputContainer)`
  justify-content: flex-end;
`;

const CreateOrUpdatePreservedFilters = () => {
  const dispatch = useDispatch();

  const t = utils.intl.useTranslator();
  const modalProps: {
    selectedFolder: DropDownOptions;
    selectedReport: DropDownOptions;
    selectItems: {
      columnHeader: string;
      columnName: string;
    }[];
    filters: ReportFilter[];
  } = useSelector(selectors.modal.getModalProps);
  const optionsFilterPreference = useSelector(selectors.userReportSettings.getOptionsFilterPreference);
  const selectedFilterPreference = useSelector(selectors.userReportSettings.getSelectedFilterPreference);

  const [value, setValue] = useState<string>(selectedFilterPreference?.settingType ?? '');

  const handleConfirm = async () => {
    try {
      const { selectedFolder, selectedReport, selectItems, filters } = modalProps;
      const obj = {
        idReport: parseInt(selectedReport.value),
        idFolder: parseInt(selectedFolder.value),
        settingType: value,
        filtersJson: filters,
        selectItemsJson: selectItems,
      };

      const { data } = await services.saveOrUpdateReportSettings(obj);

      const updatedOptionsFilterPreference = optionsFilterPreference.map((item) => {
        if (item.idUserReportSetting === data.id) {
          return {
            idUserReportSetting: data.id,
            ...obj,
          };
        }
        return item;
      });

      if (!optionsFilterPreference.some((item) => item.idUserReportSetting === data.id)) {
        updatedOptionsFilterPreference.push({
          idUserReportSetting: data.id,
          ...obj,
        });
      }

      dispatch(action.userReportSettings.setOptionsFilterPreference(updatedOptionsFilterPreference));
      dispatch(
        action.userReportSettings.setSelectedFilterPreference({
          idUserReportSetting: data.id,
          ...obj,
        }),
      );
      utils.app.notify('success', t(data.message));
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Modal.Header title={t('save-update-filters')} />
      <Modal.Content>
        <InputContainerCenter>
          <label>{t('setting-name-of-filters')}</label>
          <TextInput
            id="setting-name-of-filters"
            value={value}
            onChange={(e: any) => setValue(e.target.value)}
            disabled={!!selectedFilterPreference}
          />
        </InputContainerCenter>
      </Modal.Content>
      <Modal.Footer confirmAction={handleConfirm} confirmText={t('save')} />
    </>
  );
};
export default CreateOrUpdatePreservedFilters;
